import React from 'react';

function LoaderKino() {
  return (
   <svg className="svg" viewBox="0 0 100 100" preserveAspectRatio="none">
			<rect x="43" y="25" width="14" height="50" />
		</svg>
  );
}
export default LoaderKino;
